import React, { PropsWithChildren, ReactElement } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerGeneralHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerProps,
} from '@wegroup/design-system';

interface Props {
  rightElement?: ReactElement;
  title: string;
  description?: string;
  icon?: ReactElement;
}

const EntityDrawer: React.FC<PropsWithChildren & DrawerProps & Props> = ({
  rightElement,
  title,
  description,
  icon,
  children,
  ...props
}) => {
  return (
    <Drawer placement="right" size="lg" {...props}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerGeneralHeader
          title={title}
          description={description}
          icon={icon}
          rightElement={rightElement}
        />
        <DrawerBody>{children}</DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default EntityDrawer;
